module.exports = __webpack_public_path__ + "static/produck-6e4560aee920d98da8554037ed515847.svg";